module.exports = __webpack_public_path__ + "img/time-travel.1d9b780e.jpg";